import { Link } from "react-router-dom";

import styles from "../../styles/title.module.scss";
import { ArrowLeftIcon } from "./Icons";
import { useIsMobile } from "shared/hooks/useIsMobile";

export const Title = ({ title, subtitle, backTo, onBack, children }) => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.titleContainer}>
      <div className="d-flex flex-column justify-center">
        <div className={styles.title} alt={title}>{title}</div>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {(backTo || onBack) && (
          <div className={styles.back}>
            {backTo && (
              <Link to={isMobile ? '/' : backTo.url}>
                <ArrowLeftIcon />
                <span>{isMobile ? 'Tela inicial' : backTo.name}</span>
              </Link>
            )}
            {onBack && (
              <p onClick={() => onBack.callback()}>
                <ArrowLeftIcon />
                <span>{onBack.name}</span>
              </p>
            )}
          </div>
        )}
      </div>

      <div className={styles.content}>{children}</div>
    </div>
  );
};
